import { SettingsTabs } from "@/components/Settings"
import { TwoFactor } from "@/components/two-factor/TwoFactor"
import { TwoFactorRegister } from "@/components/two-factor/TwoFactorRegister"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { memo } from "react"
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom"

const SettingsPageComponent = () => {
  const { path } = useRouteMatch()

  const isMobile = useMediaQuery("(max-width: 768px)")

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "50px", pointerEvents: "all" }}>
      <div
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: isMobile ? "column" : "row", gap: "24px" }}
      >
        <span style={{ color: "#0D1118", fontSize: "30px", lineHeight: "36px" }}>My Profile</span>
        <div style={{ backgroundColor: "#ffffff", padding: "8px 30px", color: "#777E8A", fontSize: "14px", lineHeight: "28px" }}>
          You have full control to manage your own account setting
        </div>
      </div>

      <div className="container bg-white p-0 flex flex-col border">
        <SettingsTabs />
        <Switch>
          <Route path={`${path}/two-factor/register`}>
            <TwoFactorRegister />
          </Route>
          <Route path={`${path}/two-factor`}>
            <TwoFactor />
          </Route>

          <Redirect to={`${path}/two-factor`} />
        </Switch>
      </div>
    </div>
  )
}

export const SettingsPage = memo(SettingsPageComponent)
